var $ = require('jquery');

/**
 * Log playback errors.
 *
 * http://docs.videojs.com/MediaError.html
 *
 * @param {Object} player
 * @param {MediaError} error
 */
var logError = function(player, error) {
    var playerId = player.id();
    var fileId = playerId.split('-').pop();

    $.ajax({
        url: '/video-log/'+fileId+'/error',
        method: 'POST',
        dataType: 'json',
        data: {
            code: error.code,
            message: error.message,
            status: error.status,
            fileId: fileId,
            location: window.location.pathname,
            userAgent: window.navigator.userAgent
        }
    });
};

module.exports = logError;
